import { EINREICHUNG_STORE_KEY } from '../reducers';
import { EinreichungState } from '../reducers/einreichung.reducer';
import { UploadStatus } from '../enums';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const getUploadState = createFeatureSelector<EinreichungState>(EINREICHUNG_STORE_KEY);

export const selectUploadError = createSelector(getUploadState, (state: EinreichungState) => state.upload.error);

export const selectUploadReady = createSelector(
  getUploadState,
  (state: EinreichungState) => state.upload.status === UploadStatus.Ready,
);

export const selectUploadRequested = createSelector(
  getUploadState,
  (state: EinreichungState) => state.upload.status === UploadStatus.Requested,
);

export const selectUploadStarted = createSelector(
  getUploadState,
  (state: EinreichungState) => state.upload.status === UploadStatus.Started,
);

export const selectUploadInProgress = createSelector(getUploadState, (state: EinreichungState) => {
  const progress = state.upload.progress || 0;
  if (progress) {
    state.upload.status === UploadStatus.Started && progress >= 0;
  }
});

export const selectUploadFailed = createSelector(
  getUploadState,
  (state: EinreichungState) => state.upload.status === UploadStatus.Failed,
);

export const selectUploadCompleted = createSelector(
  getUploadState,
  (state: EinreichungState) => state.upload.status === UploadStatus.Completed,
);

export const selectUploadCompletedCounter = createSelector(
  getUploadState,
  (state: EinreichungState) => state.upload.uploadCounter,
);

export const selectUploadFailedAppendixNumber = createSelector(
  getUploadState,
  (state: EinreichungState) => state.upload.failedUploadList,
);

export const selectUploadProgress = createSelector(getUploadState, (state: EinreichungState) => ({
  total: state.upload.totalFiles || 0,
  success: state.upload.successFiles || 0,
  failed: state.upload.failedFiles || 0,
}));
